import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div {{on \"click\" (stop-propagation @clickHandler)}} role=\"button\">\n  {{yield}}\n</div>")